(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-column-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGColumnTextSwiper extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        if (this.swiper) return;
        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-column-text-swiper')) {
      customElements.define('yg-column-text-swiper', YGColumnTextSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-grid"] && !Shopify.designMode) return;
  try {
    
  class YGGridController {
    constructor(root) {
      this.root = root;
      this.onItemClick = this.onItemClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.root.addEventListener('click', this.onItemClick);
      window.addEventListener('resize', this.onResize);
    }

    get isMobile() {
      return window.matchMedia('(max-width: 699px)').matches;
    }

    onItemClick(event) {
      if (!this.isMobile) {
        return;
      }

      const item = event.target.closest("[data-yg-grid-item][data-has-overlay='true']");

      if (!item || !this.root.contains(item)) {
        return;
      }

      const shouldOpen = !item.classList.contains('is-active');

      this.root.querySelectorAll('[data-yg-grid-item].is-active').forEach((activeItem) => {
        activeItem.classList.remove('is-active');
      });

      if (shouldOpen) {
        item.classList.add('is-active');
      }
    }

    onResize() {
      if (!this.isMobile) {
        this.root.querySelectorAll('[data-yg-grid-item].is-active').forEach((item) => {
          item.classList.remove('is-active');
        });
      }
    }
  }

  const initYGGrid = (scope = document) => {
    scope.querySelectorAll('.yg-grid').forEach((grid) => {
      if (grid.dataset.ygGridReady === 'true') {
        return;
      }

      grid.dataset.ygGridReady = 'true';
      new YGGridController(grid);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initYGGrid(document));
  } else {
    initYGGrid(document);
  }

  initYGGrid(document);
  document.addEventListener('shopify:section:load', (event) => initYGGrid(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v1"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        controls: this.querySelectorAll('.yg-process-steps-media'),
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();
})();
